const idEntitySendSetter = (values: any, array: string[]) =>
  Object.fromEntries(
    Object.entries(values).map(item => {
      const [key, value] = item
      if (array.includes(key)) {
        return [
          key,
          {
            id: value,
          },
        ]
      }
      return item
    }),
  )

export default idEntitySendSetter
